package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class UserDto(
    val id: String,
    val email: String,
    val username: String,
    val fullName: String? = null,
    val avatarUrl: String? = null,
    val isActive: Boolean? = null,
    val isEmailVerified: Boolean? = null,
    val activeRole: String? = null,
    /**
     * Whether the user has already spent their one free AI-avatar generation.
     * Every user gets one free generation before the subscription paywall kicks
     * in; the backend flips this to true after the first generation and returns
     * HTTP 402 for subsequent ones without an active subscription.
     */
    val freeAvatarUsed: Boolean = false,
    /**
     * Main card on the profile — the first entry (lowest `displayOrder`)
     * from the user's profile-card gallery. Backend sends this; the rest
     * of the gallery is fetched via the dedicated profile-cards endpoint.
     */
    val mainProfileCard: ProfileCardDto? = null,
    val bio: String? = null,
    val phone: String? = null,
    val city: String? = null,
    /** City-centre coordinates matching [city] — captured from the city
     *  autocomplete pick; null when the city was typed manually. */
    val cityLat: Double? = null,
    val cityLng: Double? = null,
    val country: String? = null,
    val dateOfBirth: String? = null,
    /** Canonical "MALE" / "FEMALE" (user-picked in the Personal Info form). */
    val gender: String? = null,
    val languages: List<String> = emptyList(),
    val interestSports: List<String> = emptyList(),
    val interestActivities: List<String> = emptyList(),
    val interestLifestyle: List<String> = emptyList(),
    val interestNotes: Map<String, String> = emptyMap(),
    val createdAt: String? = null,
    val updatedAt: String? = null
)

@Serializable
data class UpdateUserRequest(
    val fullName: String? = null,
    val avatarUrl: String? = null,
    val bio: String? = null,
    val phone: String? = null,
    val city: String? = null,
    /** Send together with [city]; the backend drops stored coordinates on a
     *  city change that arrives without a fresh pair. */
    val cityLat: Double? = null,
    val cityLng: Double? = null,
    val country: String? = null,
    val dateOfBirth: String? = null,
    /** Canonical "MALE" / "FEMALE"; null = leave unchanged. */
    val gender: String? = null,
    val languages: List<String>? = null,
    val interestSports: List<String>? = null,
    val interestActivities: List<String>? = null,
    val interestLifestyle: List<String>? = null,
    val interestNotes: Map<String, String>? = null
)

@Serializable
data class UpdateActiveRoleRequest(
    val role: String
)
